import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLocalizedPath } from "@/lib/getLocalizedPath";

const LANGUAGES = ["es", "en", "pt", "fr"] as const;
const BASE_URL = "https://gandaraschool.com";

export function useHreflang() {
  const location = useLocation();

  useEffect(() => {
    const existing = document.querySelectorAll('link[data-hreflang]');
    existing.forEach((el) => el.remove());

    LANGUAGES.forEach((lang) => {
      const localizedPath = getLocalizedPath(location.pathname, lang);
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = lang;
      link.href = `${BASE_URL}${localizedPath}`;
      link.setAttribute("data-hreflang", "true");
      document.head.appendChild(link);
    });

    // x-default points to Spanish version
    const xDefault = document.createElement("link");
    xDefault.rel = "alternate";
    xDefault.hreflang = "x-default";
    xDefault.href = `${BASE_URL}${getLocalizedPath(location.pathname, "es")}`;
    xDefault.setAttribute("data-hreflang", "true");
    document.head.appendChild(xDefault);

    return () => {
      document.querySelectorAll('link[data-hreflang]').forEach((el) => el.remove());
    };
  }, [location.pathname]);
}
